import React from "react";
import { collectionLabel } from "./cleanStartLabels";

export function CountsTable({ counts }) {
  const rows = Object.entries(counts || {}).sort(([, a], [, b]) => b - a);
  return (
    <details className="border border-black" data-testid="clean-start-counts">
      <summary className="cursor-pointer p-2 text-xs font-bold uppercase tracking-widest bg-zinc-50">
        Everything that will be removed <span className="font-mono normal-case text-zinc-600">· {rows.length} kinds of records</span>
      </summary>
      <div className="max-h-56 overflow-y-auto">
        {rows.map(([k, v]) => (
          <div key={k} className="grid grid-cols-[1fr_auto] text-xs border-t border-zinc-200" data-testid={`clean-start-count-${k}`}>
            <div className="p-2">{collectionLabel(k)}</div>
            <div className="p-2 font-mono font-bold text-right">{v.toLocaleString()}</div>
          </div>
        ))}
        {!rows.length && <div className="p-2 text-xs text-zinc-500">Nothing left to remove. The site is already clean.</div>}
      </div>
    </details>
  );
}

export function KeptNote({ untouched }) {
  return (
    <div className="border border-emerald-800 bg-emerald-50 p-3 text-xs text-emerald-950 space-y-1" data-testid="clean-start-kept-note">
      <div className="font-bold uppercase tracking-widest">Stays exactly as it is</div>
      <div>
        Platform settings, casequoter.com setup, legal pages, TrustedForm and bot-check setup, marketing pixels,
        thank-you templates, help guides and uploaded images. ({untouched.length} kinds of settings records are not touched.)
      </div>
    </div>
  );
}
